import { Link } from "react-router-dom";
import { BiCartAlt } from "react-icons/bi";

const ShopBoxIcon = ({ itemCount, numbe }) => {
  return (
    <div className="flex flex-row justify-center items-center text-center relative">
      {/* Cart Icon */}
      <Link to="/shop-box">
        <BiCartAlt className="sm:size-6 size-8" />
      </Link>

      {/* Cart Indicator */}
      {itemCount > 0 && (
        <span
          className={`absolute -top-2 -right-2 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs ${
            numbe ? "animate-pulse" : ""
          }`}
        >
          {itemCount}
        </span>
      )}
    </div>
  );
};

export default ShopBoxIcon;